export default class {
    constructor(id, name, messengerGroupId, messengerThreadId) {
        this.id = id;
        this.name = name;
        this.messengerGroupId = messengerGroupId;
        this.messengerThreadId = messengerThreadId;
        this.members = [];
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }

    getMembers() {
        return this.members;
    }

    addMember(member) {
        this.members.push(member);
    }

    getMessengerGroupId() {
        return this.messengerGroupId;
    }

    getMessengerThreadId() {
        return this.messengerThreadId;
    }
}
